import React, { memo, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { makeSelectSpecialFilterContent, makeSelectSpecialFilterDataArray, makeSelectSpecialFilterId } from '../selectors';
import { loadCourses } from '../../App/actions';
import { setSpecialFilterDataArray, setSpecialFilterId } from '../actions';
import { toggleSpecialFilterMenu } from './actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import FilterElementRadio from '../../../components/FilterElement/FilterElementRadio';

export const Items = ({
  specialItems,
  onSetSpecialFilterId,
  onLoadCourses,
  specialFilterId,
  specialFilterDataArray,
  onSetSpecialFilterDataArray,
}) => {
  useEffect(() => {
    console.log("specialFilterID changed", specialFilterId)
    onLoadCourses();
  }, [specialFilterId]);

  const toggleFilterIds = (item) => {
    const itemIndex = specialFilterId.indexOf(item.id);
    if (itemIndex >= 0) {
      onSetSpecialFilterId([...specialFilterId.slice(0, itemIndex), ...specialFilterId.slice(itemIndex + 1)]);
      onSetSpecialFilterDataArray([
        ...specialFilterDataArray.slice(0, itemIndex),
        ...specialFilterDataArray.slice(itemIndex + 1),
      ]);
    } else {
      onSetSpecialFilterId([item.id, ...specialFilterId]);
      onSetSpecialFilterDataArray([item.name, ...specialFilterDataArray]);
    }
  };

  if (specialItems.length === 0) {
    return <>Special</>;
  }


  return specialItems.map((entry) => {
    const item = Object.entries(entry)[0];
    return (
      <div key={item[1].id} onClick={() => toggleFilterIds(item[1])}>
        <FilterElementRadio
          title={item[1].name}
          status={specialFilterId.indexOf(item[1].id) >= 0}
          bubble={''}
          position={0}
        />
      </div>
    );
  });
};

Items.propTypes = {
  onLoadCourses: PropTypes.func,
  specialItems: PropTypes.array,
  onSetSpecialFilterId: PropTypes.func,
  specialFilterDataArray: PropTypes.array,
};

Items.defaultProps = {
  onLoadCourses: () => {},
  specialItems: [],
  specialFilterDataArray: [],
  onSetSpecialFilterId: () => {},
};

const mapStateToProps = createStructuredSelector({
  specialFilterId: makeSelectSpecialFilterId(),
  specialItems: makeSelectSpecialFilterContent(),
  specialFilterDataArray: makeSelectSpecialFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onSetSpecialFilterId: (value) => dispatch(setSpecialFilterId(value)),
    onToggleSpecialFilterMenu: (value) => dispatch(toggleSpecialFilterMenu(value)),
    onSetSpecialFilterDataArray: (value) => dispatch(setSpecialFilterDataArray(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Items);
